<div
  class="relative flex-shrink-0 overflow-hidden rounded-[12px] border-2 border-gray-200 bg-transparent transition-all"
  [class.h-[350px]]="type() === 'customer-offer'"
  [class.w-full]="type() === 'customer-offer'"
  [class.w-[70vw]]="type() === 'offer'"
  [class.w-[320px]]="type() === 'product' || type() === 'customer-product'"
  [class.h-[220px]]="type() === 'product' || type() === 'customer-product' || type() === 'offer'"
  [ngClass]="type() === 'customer-product' ? '!h-full w-full' : ''">
  @if (currentImage().url) {
    <img
      [src]="currentImage().url"
      alt="Product Image"
      class="h-full w-full object-cover p-2 transition-opacity duration-300" />
  } @else {
    <div class="flex h-full w-full items-center justify-center bg-gray-50">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 48 48">
        <g class="fill-border-input">
          <path d="M37.084 15.735a1 1 0 1 0 .448-1.949l-6.616-1.52a1 1 0 1 0-.448 1.948z" />
          <path
            fill-rule="evenodd"
            d="M34 22a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12M16.778 9.245c-.647-1.532-2.813-1.686-3.682-.263L6.292 20.115c-.785 1.284.092 2.924 1.623 3.033l11.866.846c1.53.11 2.644-1.388 2.06-2.77zm-1.967.768l-.009.012L8.01 21.14l.002.002l.01.004a.1.1 0 0 0 .036.007l11.867.846h.038a.1.1 0 0 0 .029-.015l-5.056-11.96l-.004-.01a.1.1 0 0 0-.054-.014a.13.13 0 0 0-.062.009l-.003.001v.001zM35.385 36.36a6 6 0 0 0-5.071-10.876l-10.876 5.07a6 6 0 1 0 5.071 10.877zm-15.102-3.992a4 4 0 1 0 3.381 7.25l4.466-2.083l-3.38-7.25zm9.66 4.322l-3.381-7.25l4.597-2.144a4 4 0 1 1 3.38 7.25z"
            clip-rule="evenodd" />
        </g>
      </svg>
    </div>
  }

  @if (isLoading()) {
    <div class="absolute inset-0 flex items-center justify-center bg-white/70 backdrop-blur-[2px]">
      <div class="border-primary h-8 w-8 animate-spin rounded-full border-3 border-t-transparent"></div>
    </div>
  }

  @if (allImages().length > 1) {
    <div class="absolute right-0 bottom-2 left-0 flex justify-center gap-4">
      @for (img of allImages(); track $index) {
        <button
          (click)="goTo($index)"
          class="h-2 w-2 cursor-pointer rounded-full bg-gray-600 transition-all duration-200"
          [class]="activeIndex() === $index ? 'activeDot' : 'notActiveDot hover:bg-white'"></button>
      }
    </div>

    @if (isArabic()) {
      <button
        (click)="next()"
        class="absolute top-1/2 left-1 -translate-y-1/2 cursor-pointer rounded-full bg-gray-50 p-1 text-gray-600 transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 15 15">
          <path class="stroke-helper" fill="none" stroke-linecap="square" d="M10 14L3 7.5L10 1" stroke-width="1" />
        </svg>
      </button>
      <button
        (click)="prev()"
        class="absolute top-1/2 right-1 -translate-y-1/2 cursor-pointer rounded-full bg-gray-50 p-1 text-gray-600 transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 15 15">
          <path class="stroke-helper" fill="none" stroke-linecap="square" d="m5 14l7-6.5L5 1" stroke-width="1" />
        </svg>
      </button>
    } @else {
      <button
        (click)="prev()"
        class="absolute top-1/2 left-1 -translate-y-1/2 cursor-pointer rounded-full bg-transparent transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 15 15">
          <path class="stroke-helper" fill="none" stroke-linecap="square" d="M10 14L3 7.5L10 1" stroke-width="1" />
        </svg>
      </button>
      <button
        (click)="next()"
        class="absolute top-1/2 right-1 -translate-y-1/2 cursor-pointer rounded-full bg-transparent transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 15 15">
          <path class="stroke-helper" fill="none" stroke-linecap="square" d="m5 14l7-6.5L5 1" stroke-width="1" />
        </svg>
      </button>
    }
  }
</div>
